import React from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Typography } from "@mui/material";
import type { EmailHistoryRecord } from "../../../types";

interface Props {
  open: boolean;
  email: EmailHistoryRecord | null;
  onClose: () => void;
}

export default function StudyEmailDetailsDialog({ open, email, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Email Details</DialogTitle>
      <DialogContent>
        {email && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* Box 1: Email Title */}
            <Paper
              sx={{
                p: 2,
                bgcolor: "primary.main",
                color: "primary.contrastText",
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {email.emailSubject}
              </Typography>
            </Paper>

            {/* Line 2: Recipients */}
            <Paper
              sx={{
                p: 2,
                bgcolor: "background.paper",
                border: 1,
                borderColor: "divider",
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, mb: 1, color: "text.secondary" }}
              >
                RECIPIENTS ({email.sentCount})
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  color: "text.primary",
                  wordBreak: "break-all",
                }}
              >
                {email.participants &&
                email.participants.length > 0
                  ? email.participants
                      .map((p: any) => p.email || p.participantEmail)
                      .join(", ")
                  : `${email.sentCount} recipients`}
              </Typography>
            </Paper>

            {/* Box 3: Email Content */}
            <Paper
              sx={{
                p: 3,
                border: 1,
                borderColor: "divider",
                bgcolor: "background.paper",
              }}
            >
              <Typography
                variant="body1"
                sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}
              >
                {email.emailBody || "Email content not available"}
              </Typography>
            </Paper>

            {/* Additional Info */}
            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 1 }}
            >
              Sent on {new Date(email.sentAt).toLocaleString()} •
              Status: {email.deliveryStatus}
            </Typography>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}
